<script setup lang="ts">
import Button from '@/components/ui/button/Button.vue'
import { Portal } from '@linusborg/vue-simple-portal'
import { NotifiedUserViewModel } from './viewmodels/NotifiedUser.viewmodel'
import { NotifiedUserRepositoryApiAdapter } from '../../../../../@core/fire-risk-settings/infra/notified-user-repository-adapter/NotifiedUserRepositoryApi.adapter'
import SidePanel from '@/components/ui/sidePanel/SidePanel.vue'
import NotifiedUserForm from './components/NotifiedUserForm.vue'
import { onBeforeMount, provide, watch } from 'vue'
import BaseTable from '../../../../ui/components/baseTable/BaseTable.vue'
import Pagination from '@/components/ui/pagination/Pagination.vue'
import Input from '@/components/ui/input/Input.vue'
import EmptyTable from '@/components/ui/emty-table/EmptyTable.vue'
import ContextMenu from '@/components/ui/contextMenu/ContextMenu.vue'
import ConfirmationModal from '@/components/ui/confirmation-modal/ConfirmationModal.vue'
import { fireRiskApi } from '@/services/clients/AxiosClients'
import TelegramModal from './components/TelegramModal.vue'
import { MonitoredAreaRepositoryApiAdapter } from '@/@core/monitored-area/infra/monitored-area-repository-adapter/MonitoredAreaRepositoryApi.adapter'
const repository = new NotifiedUserRepositoryApiAdapter(fireRiskApi)

const monitoredAreaRepository = new MonitoredAreaRepositoryApiAdapter(fireRiskApi)

const vm = new NotifiedUserViewModel(repository, monitoredAreaRepository)

provide('notified-user-view-model', vm)

watch(vm.openForm, (value) => {
	if (!value) vm.resetNotifiedUserState()
})

onBeforeMount(() => vm.getNotifiedUsers())
</script>

<template>
	<main>
		<div class="flex justify-between my-4">
			<div class="flex gap-4">
				<Button
					icon="fa6-solid:trash"
					text="excluir"
					class="!outline-none"
					:disabled="!vm.registry.entriesToDelete.value.length"
					:class="[!vm.notifiedUsers.value?.length ? 'disabled:opacity-70' : '']"
					danger
					simple
					@click="vm.showDeletePopup.value = true"
				/>
				<Button
					text="cadastrar"
					@click="vm.openForm.value = true"
				/>
			</div>
			<div
				style="display: flex"
				class="gap-4"
			>
				<Input
					v-model="vm.registry.searchTerm.value"
					search
					placeholder="Pesquisar"
					@clear="vm.registry.searchTerm.value = ''"
				/>
				<Button
					:disabled="!vm.notifiedUsers.value?.length"
					text="exportar"
					secondary
					simple
					@click="() => vm.exportDataTable()"
				/>
			</div>
		</div>

		<base-table
			:checked.sync="vm.registry.entriesToDelete.value"
			:colunas="vm.colunas.value"
			:data="vm.registry.pageData.value"
			@sort="vm.registry.handleSort($event)"
		>
			<template #custom-edit="dado">
				<ContextMenu
					:item-id="dado.id"
					:options="vm.kebabOptions()"
					@editar="vm.loadNotifiedUser(dado.id)"
				/>
			</template>
		</base-table>

		<pagination
			v-if="vm.registry.pageData.value?.length"
			:key="vm.registry.searchTerm.value"
			class="mt-4"
			:total="vm.notifiedUsers.value?.length || 0"
			:page="vm.registry.page.value"
			:page-size="vm.registry.pageSize.value"
			@paginationSettings="vm.registry.onPageChange"
		/>

		<empty-table
			v-if="!vm.registry.pageData.value.length"
			:key="vm.registry.searchTerm.value"
			registry-name="Usuário notificado"
			:search="vm.registry.searchTerm.value"
			@clear="vm.registry.searchTerm.value = ''"
		/>

		<Portal selector="body">
			<side-panel
				:change-is-visible="() => (vm.openForm.value = false)"
				:is-visible="vm.openForm.value"
				backdrop
			>
				<notified-user-form
					:loading="vm.fetching.value"
					@cancel="() => (vm.openForm.value = false)"
					@submit="() => vm.createNotifiedUser()"
				/>
			</side-panel>
		</Portal>
		<confirmation-modal
			v-if="vm.showDeletePopup.value"
			title="Tem certeza que deseja excluir esses usuários notificados?"
			subtitle="A ação não poderá ser desfeita."
			:loading="vm.fetching.value"
			:items="vm.getNotifiedUsersToDelete()"
			@delete="() => vm.deleteNotifiedUsers()"
			@cancel="vm.showDeletePopup.value = false"
		/>

		<telegram-modal
			v-if="vm.createdUserId.value"
			@close="vm.createdUserId.value = undefined"
			:user-id="vm.createdUserId.value"
		/>
	</main>
</template>

<style scoped>
:deep(.container__crudform__panel.container__crudform__panel__visible) {
	width: 610px;
}
</style>
